<template>
    <div class="container">
    <div class="container__form__wrapper">
        <p class="container__form__headline">Contact</p>
      <form class="container__form" @submit.prevent="sendMail">
        <div class="container__form__input-fields">
          <input type="text" class="form__input" placeholder="Name" v-model="contactData.name">
          <input type="text" class="form__input" placeholder="Email" v-model="contactData.email">
          <input type="text" class="form__input" placeholder="Phone" v-model="contactData.phone"> 
          <input type="text" class="form__input" placeholder="Subject" v-model="contactData.subject">
        </div>
        <div class="container__form__textarea">
          <textarea placeholder="Type your message here" v-model="contactData.message"></textarea>
          <div class="btn--tertiary" id="btnmsg" v-on:click="userMsg">Send</div>
        </div>
      </form>
    </div>
    </div>
</template>

<script>
export default {
    name: 'Contact',
    data: function () {
        return {
            contactData: {
                name: '',
                email: '',
                phone: '',
                subject: '',
                message: '',
            },
            success: false,
            error: false,
        }
    },
    methods: {
        sendMail: function () {
            // in a real app, it would be better if the URL is extracted as a env variable
            const {name, email, phone, subject, message} = this.contactData;
            const payload = {name, email, phone, subject, message};
            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            })
                .then(() => {
                    this.success = true;
                    this.resetForm();
                })
                .catch(() => {
                    this.error = true;
                })
        },
        resetForm: function () {
            this.contactData = {
                name: '',
                email: '',
                phone: '',
                subject: '',
                message: '',
            };
        },
        userMsg: function(event) {
          alert('Thank you for your message. You will be contacted shortly')
          if (event) {

      }
        }
    },
}
</script>


<style lang="scss">
@import "~@/assets/styles/main.scss";
</style>


// WEBPACK FOOTER //
// src/components/Contact.vue